// @ts-nocheck
import React from 'react';
import HealthChecksList from './components/HealthCheckList';
import { usePageTitle } from '../../../util/pageTitle';

export default function HealthChecks() {
  const [pageTitle, setPageTitle] = usePageTitle(['Health checks', 'Settings']);
  return <HealthChecksList ></HealthChecksList>;
}
